import {Component} from "@angular/core";
import {MatLegacyDialogRef as MatDialogRef} from "@angular/material/legacy-dialog";
import {DisplayCompte} from "@domain/comptabilite/compte";

/**
 * Composant d'ajout d'un compte charge
 */
@Component({
    host: {'data-test-id': 'add-compte-externe'},
    selector: 'add-compte-externe',
    templateUrl: './add-compte-externe.component.html'
})
export class AddCompteExterneComponent {
    /** Compte charge à ajouter */
    compte: DisplayCompte = new DisplayCompte();

    /**
     * Constructeur
     */
    constructor(protected matDialogRef: MatDialogRef<AddCompteExterneComponent>) {}

    /**
     * Ajout du compte charge
     */
    add(): void {
        //Mise à jour de l'affichage
        this.compte.updateDisplayName();

        //Fermeture de la boite de dialogue avec retour du nouveau compte externe
        this.matDialogRef.close(this.compte);
    }
}
